"use client";

import StudentsCarousel, {
  StudentsVideoCarousel,
} from "@/components/studentsCarousel/StudentsCarousel";
import { StudentsGridCarousel } from "@/components/sections/StudentsCarousel";
import style from "./style.module.scss";
import cn from "clsx";

export default function StudentTestimonialsSection({
  testimonials,
  videoTestimonials,
  sectionHeading = ""
}: {
  StudentTestimonials?: any;
  isDesktop?: boolean;
  testimonials: any;
  videoTestimonials: any;
  sectionHeading?: string;
}) {

  return (
    <>
      <div className={style.gridContainer}>
        <StudentsGridCarousel
          studentsDetails={testimonials}
          videoTestimonials={videoTestimonials}
          sectionHeading={sectionHeading}
        />
      </div>

      <div className={cn("px-9 sm:px-[1.2rem]", style.carouselContainer)}>
        <StudentsCarousel studensDetails={testimonials} />
        <StudentsVideoCarousel studentsDetails={videoTestimonials} />
      </div>
    </>
  )
}
